import constants from 'constants/index'

const mountServiceData = (serviceId) => {
  return constants.marketplace.pages.services[serviceId]
}

export default mountServiceData
